module.exports = __webpack_public_path__ + "static/img/web_7_activities_mobile orginal.f524dfd9.jpg";